import { createContext, useContext, useMemo, useState } from 'react'

/** Pixels past the pointer when anchoring floating chart tooltips (top-left of panel). */
export const FLOATING_CHART_TOOLTIP_CURSOR_OFFSET_PX = 8

export type ChartTooltipClientPoint = { clientX: number; clientY: number }

const ChartTooltipPointerContext =
  createContext<ChartTooltipClientPoint | null>(null)

export const useChartTooltipPointer = () =>
  useContext(ChartTooltipPointerContext)

export type ChartAreaMouseHandlers = {
  onMouseMove: (e: React.MouseEvent) => void
  onMouseLeave: () => void
}

/**
 * Supplies client pointer position for floating chart tooltips. Pass `mouseHandlers`
 * into RechartsWrapper `chartAreaMouseTracking`.
 */
interface FloatingChartTooltipShellProps {
  children: (mouseHandlers: ChartAreaMouseHandlers) => React.ReactNode
}

export const FloatingChartTooltipShell = ({
  children,
}: FloatingChartTooltipShellProps) => {
  const [point, setPoint] = useState<ChartTooltipClientPoint | null>(null)

  const mouseHandlers = useMemo(
    (): ChartAreaMouseHandlers => ({
      onMouseMove: e => {
        setPoint({ clientX: e.clientX, clientY: e.clientY })
      },
      onMouseLeave: () => {
        setPoint(null)
      },
    }),
    [],
  )

  return (
    <ChartTooltipPointerContext.Provider value={point}>
      {children(mouseHandlers)}
    </ChartTooltipPointerContext.Provider>
  )
}
